import type { OrganizationQuotas } from "@t3tools/contracts";
import { useEffect, useState } from "react";

export function nextQuotaChangeAt(quotas: OrganizationQuotas, nowMs: number) {
  const midnight = new Date(nowMs);
  midnight.setHours(24, 0, 0, 0);
  return Math.min(
    midnight.getTime(),
    ...[...quotas.agent.budgets, ...quotas.ocr.budgets]
      .flatMap((budget) => (budget.resetsAt ? [Date.parse(budget.resetsAt)] : []))
      .filter((time) => time > nowMs),
  );
}

export function useQuotaClock(quotas: OrganizationQuotas | null) {
  const [nowMs, setNowMs] = useState(Date.now);
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const tick = () => {
      const now = Date.now();
      setNowMs(now);
      if (quotas) timer = setTimeout(tick, nextQuotaChangeAt(quotas, now) - now);
    };
    tick();
    return () => clearTimeout(timer);
  }, [quotas]);
  return nowMs;
}
